export enum LimitType {
  UNKNOWN = 0,
  FIXED = 1,
  NOLIMIT = 2,
  POTLIMIT = 3,
}
